import React from 'react';
import { DashboardIcon, SideMenuCancelReasonsIcon, SideMenuChangePasswordIcon, SideMenuHomePageSettingsIcon, SideMenuManageAdminIcon, SideMenuManageCategoriesIcon, SideMenuManageCurrencyIcon, SideMenuManageFaresIcon, SideMenuManageLocationsIcon, SideMenuManageSubCategoriesIcon, SideMenuManageUsersIcon, SideMenuMobileAppSettingsIcon, SideMenuPaymentMethodIcon, SideMenuPrecautionNotificationIcon, SideMenuPromoCodeIcon, SideMenuServiceProvidersIcon, SideMenuSiteConfigurationIcon, SideMenuSiteSettingsIcon, SideMenuSmsMethodIcon, SideMenuSubArrow } from "../components/Common/Assets/SVGIcon/SiteAdminIcon.js";
import { SideMenuCancelledJobsIcon, SideMenuCompletedJobsIcon, SideMenuContentManageMentIcon, SideMenuManageFailedPayoutIcon, SideMenuManageJobsIcon, SideMenuManagePayoutIcon, SideMenuManualJobsIcon, SideMenuScheduleJobsIcon, SideMenuSendNotificationsIcon, SideMenuStaticContentManageMentIcon, SideMenuTrackingIcon, SideMenuViewJobRatingsIcon } from '../components/Common/Assets/SVGIcon/SideMenuIconsRemaining.js';


const getDashboardSideMenu = [
    {
        label: "manageDashboard",
        activePaths: ["/siteadmin"],
        href: "/siteadmin",
        icon: <DashboardIcon />,
        isValidatePrivilege: false
    },
    {
        label: "reportsAnalytics",
        activePaths: ["/siteadmin/analytics"],
        href: "/siteadmin/analytics",
        icon: <DashboardIcon />,
        isValidatePrivilege: false
    }
];

const getConfigurationSideMenu = [
    {
        label: "siteSettings",
        activePaths: ["/siteadmin/settings/site"],
        href: "/siteadmin/settings/site",
        icon: <SideMenuSiteSettingsIcon />,
        isValidatePrivilege: true,
        privilegeId: 1
    },

    {
        label: "manageSiteConfig",
        activePaths: ["/siteadmin/settings/config"],
        href: "/siteadmin/settings/config",
        icon: <SideMenuSiteConfigurationIcon />,
        isValidatePrivilege: true,
        privilegeId: 1
    },

    {
        label: "mobileSettings",
        activePaths: ["/siteadmin/settings/mobile-app"],
        href: "/siteadmin/settings/mobile-app",
        icon: <SideMenuMobileAppSettingsIcon />,
        isValidatePrivilege: true,
        privilegeId: 1,
    },
    {
        label: "serviceRegions",
        activePaths: ["/siteadmin/regions"],
        href: "/siteadmin/regions",
        icon: <SideMenuManageLocationsIcon />,
    },
    {
        label: "marketingTracking",
        activePaths: ["/siteadmin/settings/marketing"],
        href: "/siteadmin/settings/marketing",
        icon: <SideMenuSiteSettingsIcon />,
    },
    {
        label: "potentialClients",
        activePaths: ["/siteadmin/prospecting/clients"],
        href: "/siteadmin/prospecting/clients",
        icon: <SideMenuSendNotificationsIcon />,
    },
    {
        label: "potentialWorkers",
        activePaths: ["/siteadmin/prospecting/workers"],
        href: "/siteadmin/prospecting/workers",
        icon: <SideMenuSendNotificationsIcon />,
    },
    {
        label: "messaging",
        activePaths: ["/siteadmin/messaging"],
        href: "/siteadmin/messaging",
        icon: <SideMenuSiteSettingsIcon />,
    },

    {
        label: "manageCurrency",
        activePaths: ["/siteadmin/currency"],
        href: "/siteadmin/currency",
        icon: <SideMenuManageCurrencyIcon />,
        isValidatePrivilege: true,
        privilegeId: 23,
    },


    {
        label: "managePaymentGateWay",
        activePaths: ["/siteadmin/payment-gateway"],
        href: "/siteadmin/payment-gateway",
        icon: <SideMenuPaymentMethodIcon />,
        isValidatePrivilege: true,
        privilegeId: 21,
    },
    {
        label: "manageSmsMethod",
        activePaths: ["/siteadmin/sms-method"],
        href: "/siteadmin/sms-methods",
        icon: <SideMenuSmsMethodIcon />,
        isValidatePrivilege: true,
        privilegeId: 19,
    },

    {
        label: "HomeSiteSettings",
        activePaths: ["/siteadmin/homepage/banner", "/siteadmin/homepage/category", "/siteadmin/homepage/top-feature",
            "/siteadmin/homepage/user", "/siteadmin/homepage/partner", "/siteadmin/homepage/footer", "/siteadmin/homepage/top-feature/add"
        ],
        href: "/siteadmin/homepage/banner",
        icon: <SideMenuHomePageSettingsIcon />,
        isValidatePrivilege: true,
        isAccordion: true,
        privilegeId: 2,
        data: [
            {
                label: "homeSectionSettings",
                activePaths: ["/siteadmin/homepage/banner"],
                href: "/siteadmin/homepage/banner",
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 2
            },
            {
                label: "citySectionSettings",
                activePaths: ["/siteadmin/homepage/category"],
                href: "/siteadmin/homepage/category",
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 2
            },
            {
                label: "aboutSectionSettings",
                activePaths: ["/siteadmin/homepage/top-feature"],
                href: "/siteadmin/homepage/top-feature",
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 2
            },
            {
                label: "safetySectionSettings",
                activePaths: ["/siteadmin/homepage/user"],
                href: "/siteadmin/homepage/user",
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 2
            },
            {
                label: "signupSectionSettings",
                activePaths: ["/siteadmin/homepage/partner"],
                href: "/siteadmin/homepage/partner",
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 2
            },
            {
                label: "footerSectionSettings",
                activePaths: ["/siteadmin/homepage/footer"],
                href: "/siteadmin/homepage/footer",
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 2
            },
        ]
    },

    {
        label: "precautionNotification",
        activePaths: ["/siteadmin/precaution-notification"],
        href: "/siteadmin/precaution-notification",
        icon: <SideMenuPrecautionNotificationIcon />,
        isValidatePrivilege: true,
        privilegeId: 18,
    },

]

const getAdminUserSideMenu = [
    {
        label: "auditLog",
        activePaths: ["/siteadmin/audit-log"],
        href: "/siteadmin/audit-log",
        icon: <SideMenuManageAdminIcon />,
        isValidatePrivilege: false,
    },
    {
        label: "manageAdmin",
        activePaths: ["/siteadmin/admin-users", "/siteadmin/admin-roles"],
        icon: <SideMenuManageAdminIcon />,
        isValidatePrivilege: true,
        isAccordion: true,
        isSuperAdmin: true,

        data: [
            {
                label: "manageAdminUsers",
                activePaths: ["/siteadmin/admin-users"],
                href: "/siteadmin/admin-users",
                icon: <SideMenuSubArrow />,
            },
            {
                label: "manageAdminRoles",
                activePaths: ["/siteadmin/admin-roles"],
                href: "/siteadmin/admin-roles",
                icon: <SideMenuSubArrow />,

            }
        ]
    },
    {
        label: "changePassword",
        activePaths: ["/siteadmin/change/admin"],
        href: "/siteadmin/change/admin",
        icon: <SideMenuChangePasswordIcon />,
        isValidatePrivilege: false
    }
]

const getUserSideMenu = [
    {
        label: "user360",
        activePaths: ["/siteadmin/user-360"],
        href: "/siteadmin/user-360",
        icon: <SideMenuManageUsersIcon />,
        isValidatePrivilege: false,
    },
    {
        label: "usersMenu",
        activePaths: ["/siteadmin/users"],
        href: "/siteadmin/users",
        icon: <SideMenuManageUsersIcon />,
        isValidatePrivilege: true,
        privilegeId: 3,
    },

    {
        label: "partnerMenu",
        activePaths: ["/siteadmin/partners"],
        href: "/siteadmin/partners",
        icon: <SideMenuServiceProvidersIcon />,
        isValidatePrivilege: true,
        privilegeId: 4,
    }
];

const getOpConfiguration = [
    {
        label: "categoryMenu",
        activePaths: ["/siteadmin/category"],
        href: "/siteadmin/category",
        icon: <SideMenuManageCategoriesIcon />,
        isValidatePrivilege: true,
        privilegeId: 5,
    },

    {
        label: "sectionsMenu",
        activePaths: ["/siteadmin/sections"],
        href: "/siteadmin/sections",
        icon: <SideMenuManageCategoriesIcon />,
        isValidatePrivilege: false,
    },

    {
        label: "subCategoryMenu",
        activePaths: ["/siteadmin/sub-category"],
        href: "/siteadmin/sub-category",
        icon: <SideMenuManageSubCategoriesIcon />,
        isValidatePrivilege: true,
        privilegeId: 6,
    },
    {
        label: "location",
        activePaths: ["/siteadmin/location", '/siteadmin/edit-location/', '/siteadmin/add-location'],
        href: "/siteadmin/location",
        icon: <SideMenuManageLocationsIcon />,
        isValidatePrivilege: true,
        privilegeId: 7,
    },

    {
        label: "manageFare",
        activePaths: ["/siteadmin/pricing"],
        href: "/siteadmin/pricing/list",
        icon: <SideMenuManageFaresIcon />,
        isValidatePrivilege: true,
        privilegeId: 8,
    },
    {
        label: "managePromoCode",
        activePaths: ["/siteadmin/promo-code"],
        href: "/siteadmin/promo-code/list",
        icon: <SideMenuPromoCodeIcon />,
        isValidatePrivilege: true,
        privilegeId: 12,
    },
    {
        label: "manageCancelReason",
        activePaths: ["/siteadmin/cancel-reasons"],
        href: "/siteadmin/cancel-reasons",
        icon: <SideMenuCancelReasonsIcon />,
        isValidatePrivilege: true,
        privilegeId: 14,
    }
];

const getJobsSideMenu = [
    {
        label: "manualBookings",
        activePaths: ["/siteadmin/manual-bookings"],
        href: "/siteadmin/manual-bookings",
        icon: <SideMenuManualJobsIcon />,
        isValidatePrivilege: true,
        privilegeId: 22,
    },
    {
        label: "communityDiscount",
        activePaths: ["/siteadmin/community-discount"],
        href: "/siteadmin/community-discount",
        icon: <SideMenuPromoCodeIcon />,
        isValidatePrivilege: false,
    },

    {
        label: "bookingsMenu",
        activePaths: ["/siteadmin/jobs"],
        href: "/siteadmin/jobs",
        icon: <SideMenuManageJobsIcon />,
        isValidatePrivilege: true,
        privilegeId: 9,
    },
    {
        label: "manageSchedule",
        activePaths: ["/siteadmin/schedule-jobs"],
        href: "/siteadmin/schedule-jobs",
        icon: <SideMenuScheduleJobsIcon />,
        isValidatePrivilege: true,
        privilegeId: 9,
    },

    {
        label: "manageCompletedBooking",
        activePaths: ["/siteadmin/completed-jobs"],
        href: "/siteadmin/completed-jobs",
        icon: <SideMenuCompletedJobsIcon />,
        isValidatePrivilege: true,
        privilegeId: 9,
    },

    {
        label: "manageCancelledBookings",
        activePaths: ["/siteadmin/cancelled-jobs"],
        href: "/siteadmin/cancelled-jobs",
        icon: <SideMenuCancelledJobsIcon />,
        isValidatePrivilege: true,
        privilegeId: 9
    },

    {
        label: "bookingDropOffs",
        activePaths: ["/siteadmin/booking-attempts"],
        href: "/siteadmin/booking-attempts",
        icon: <SideMenuCancelledJobsIcon />,
        isValidatePrivilege: false,
    }

];

const payoutSideMenu = [
    {
        label: "refundsDisputes",
        activePaths: ["/siteadmin/refunds"],
        href: "/siteadmin/refunds",
        icon: <SideMenuManagePayoutIcon />,
        isValidatePrivilege: false,
    },
    {
        // Standard-booking satisfaction-guarantee claims (BookingClaim on besthand-api).
        label: "satisfactionClaims",
        activePaths: ["/siteadmin/satisfaction-claims"],
        href: "/siteadmin/satisfaction-claims",
        icon: <SideMenuManagePayoutIcon />,
        isValidatePrivilege: false,
    },
    {
        label: "jobContests",
        activePaths: ["/siteadmin/job-contests"],
        href: "/siteadmin/job-contests",
        icon: <SideMenuManagePayoutIcon />,
        isValidatePrivilege: false,
    },
    {
        label: "unsettledPayments",
        activePaths: ["/siteadmin/unsettled-payments"],
        href: "/siteadmin/unsettled-payments",
        icon: <SideMenuManagePayoutIcon />,
        isValidatePrivilege: false,
    },
    {
        label: "financeCenter",
        activePaths: ["/siteadmin/finance"],
        href: "/siteadmin/finance",
        icon: <SideMenuManagePayoutIcon />,
        isValidatePrivilege: false,
    },
    {
        label: "managePayout",
        activePaths: ["/siteadmin/payout"],
        href: "/siteadmin/payout",
        icon: <SideMenuManagePayoutIcon />,
        isValidatePrivilege: true,
        privilegeId: 15
    },

    {
        label: "manageFailedPayout",
        activePaths: ["/siteadmin/failed-payout"],
        href: "/siteadmin/failed-payout",
        icon: <SideMenuManageFailedPayoutIcon />,
        isValidatePrivilege: true,
        privilegeId: 15
    },
    {
        label: "deferredBackgroundChecks",
        activePaths: ["/siteadmin/deferred-background-checks"],
        href: "/siteadmin/deferred-background-checks",
        icon: <SideMenuManagePayoutIcon />,
        isValidatePrivilege: false
    },
    {
        label: "freeBackgroundChecks",
        activePaths: ["/siteadmin/free-background-checks"],
        href: "/siteadmin/free-background-checks",
        icon: <SideMenuManagePayoutIcon />,
        isValidatePrivilege: false
    },
    {
        // COMPLIANCE / FCRA adverse-action sequence (PRE_ADVERSE -> reasonable-wait -> FINAL).
        label: "adverseActionTitle",
        activePaths: ["/siteadmin/adverse-action"],
        href: "/siteadmin/adverse-action",
        icon: <SideMenuManagePayoutIcon />,
        isValidatePrivilege: false
    },
    {
        label: "availableJobs",
        activePaths: ["/siteadmin/available-jobs"],
        href: "/siteadmin/available-jobs",
        icon: <SideMenuManagePayoutIcon />,
        isValidatePrivilege: false
    }
];

const monitorSideMenu = [
    {
        label: "providerOnBoardingScreens",
        activePaths: ["/siteadmin/provider-onboarding-screens"],
        href: "/siteadmin/provider-onboarding-screens",
        icon: <SideMenuPrecautionNotificationIcon />,
        isValidatePrivilege: true,
        privilegeId: 24,
    },

    {
        label: "tracking",
        activePaths: ["/siteadmin/tracking"],
        href: "/siteadmin/tracking",
        icon: <SideMenuTrackingIcon />,
        isValidatePrivilege: true,
        privilegeId: 20
    },

    {
        label: "ratings",
        activePaths: ["/siteadmin/ratings"],
        href: "/siteadmin/ratings",
        icon: <SideMenuViewJobRatingsIcon />,
        isValidatePrivilege: true,
        privilegeId: 11
    }
]

const announcementSideMenu = [

    {
        label: "growthMarketing",
        activePaths: ["/siteadmin/growth"],
        href: "/siteadmin/growth",
        icon: <SideMenuSendNotificationsIcon />,
        isValidatePrivilege: false,
    },
    {
        label: "supportTickets",
        activePaths: ["/siteadmin/support"],
        href: "/siteadmin/support",
        icon: <SideMenuSendNotificationsIcon />,
        isValidatePrivilege: false,
    },
    {
        label: "manageNotifications",
        activePaths: ["/siteadmin/notifications"],
        href: "/siteadmin/notifications",
        icon: <SideMenuSendNotificationsIcon />,
        isValidatePrivilege: false,
    },
    {
        label: "categoryQuestions",
        activePaths: ["/siteadmin/category-questions"],
        href: "/siteadmin/category-questions",
        icon: <SideMenuSendNotificationsIcon />,
        isValidatePrivilege: false,
    },
    {
        label: "workerPerformance",
        activePaths: ["/siteadmin/worker-performance"],
        href: "/siteadmin/worker-performance",
        icon: <SideMenuSendNotificationsIcon />,
        isValidatePrivilege: false,
    },
]


// Big Projects (Large Projects / Custom Projects) — DETACHED admin section, home
// for all Large Projects work. Starts with Company Providers (KYB review); more
// children (projects, disputes, payouts) will be added here later.
const bigProjectsSideMenu = [
    // CONSOLIDATION (2026-06): the old "Company Providers" page
    // (/big-projects/companies → CompanyProviders.js, the PENDING-only KYB queue)
    // was removed from the menu/routes. "Manage Company" below is a strict
    // superset — it lists ALL companies with a status filter + search and carries
    // every action the old page had (approve/reject KYB, verify license/insurance,
    // suspend owner) PLUS Middesk + Stripe auto-verify. No action was lost.
    //
    // REMOVED "Large Project Categories" (/big-projects/categories): that page
    // edited a besthand-web-DB largeProject=true catalog that NOTHING consumes —
    // the Post-a-Project wizard uses a fixed 7-value enum and submits to
    // besthand-api (separate DB), and every public/SEO/search reader explicitly
    // excludes largeProject=true. It was decorative and misled admins. (Option B.)
    {
        label: "manageCompany",
        activePaths: ["/siteadmin/big-projects/manage-company"],
        href: "/siteadmin/big-projects/manage-company",
        icon: <SideMenuManageJobsIcon />,
        isValidatePrivilege: false,
    },
    {
        label: "lpSectorsMenu",
        activePaths: ["/siteadmin/big-projects/sectors"],
        href: "/siteadmin/big-projects/sectors",
        icon: <SideMenuManageJobsIcon />,
        isValidatePrivilege: false,
    },
    {
        label: "projectVisitFee",
        activePaths: ["/siteadmin/big-projects/visit-fee"],
        href: "/siteadmin/big-projects/visit-fee",
        icon: <SideMenuManageFaresIcon />,
        isValidatePrivilege: false,
    },
    {
        label: "projectEscrowRules",
        activePaths: ["/siteadmin/big-projects/escrow-rules"],
        href: "/siteadmin/big-projects/escrow-rules",
        icon: <SideMenuManageFaresIcon />,
        isValidatePrivilege: false,
    },
    {
        label: "projectPaymentMethods",
        activePaths: ["/siteadmin/big-projects/payment-methods"],
        href: "/siteadmin/big-projects/payment-methods",
        icon: <SideMenuManageFaresIcon />,
        isValidatePrivilege: false,
    },
    {
        label: "projectRequestsMenu",
        activePaths: ["/siteadmin/big-projects/requests"],
        href: "/siteadmin/big-projects/requests",
        icon: <SideMenuManageJobsIcon />,
        isValidatePrivilege: false,
    },
    {
        label: "projectQuotesMenu",
        activePaths: ["/siteadmin/big-projects/quotes"],
        href: "/siteadmin/big-projects/quotes",
        icon: <SideMenuManageFaresIcon />,
        isValidatePrivilege: false,
    },
    {
        label: "projectContractsMenu",
        activePaths: ["/siteadmin/big-projects/contracts"],
        href: "/siteadmin/big-projects/contracts",
        icon: <SideMenuStaticContentManageMentIcon />,
        isValidatePrivilege: false,
    },
    {
        label: "projectMilestonesMenu",
        activePaths: ["/siteadmin/big-projects/milestones"],
        href: "/siteadmin/big-projects/milestones",
        icon: <SideMenuManageFaresIcon />,
        isValidatePrivilege: false,
    },
    {
        label: "projectDisputesMenu",
        activePaths: ["/siteadmin/big-projects/disputes"],
        href: "/siteadmin/big-projects/disputes",
        icon: <SideMenuPrecautionNotificationIcon />,
        isValidatePrivilege: false,
    },
    {
        label: "projectFundsMenu",
        activePaths: ["/siteadmin/big-projects/funds"],
        href: "/siteadmin/big-projects/funds",
        icon: <SideMenuManagePayoutIcon />,
        isValidatePrivilege: false,
    },
    {
        label: "projectJurisdictionsMenu",
        activePaths: ["/siteadmin/big-projects/jurisdictions"],
        href: "/siteadmin/big-projects/jurisdictions",
        icon: <SideMenuManageLocationsIcon />,
        isValidatePrivilege: false,
    },
    {
        label: "projectLegalDocsMenu",
        activePaths: ["/siteadmin/big-projects/legal-docs"],
        href: "/siteadmin/big-projects/legal-docs",
        icon: <SideMenuContentManageMentIcon />,
        isValidatePrivilege: false,
    },
    {
        label: "projectAuditLogMenu",
        activePaths: ["/siteadmin/big-projects/audit-log"],
        href: "/siteadmin/big-projects/audit-log",
        icon: <SideMenuTrackingIcon />,
        isValidatePrivilege: false,
    },
    {
        label: "projectBreachMenu",
        activePaths: ["/siteadmin/big-projects/breach"],
        href: "/siteadmin/big-projects/breach",
        icon: <SideMenuManageFailedPayoutIcon />,
        isValidatePrivilege: false,
    },
    {
        label: "projectCircumventionMenu",
        activePaths: ["/siteadmin/big-projects/circumvention"],
        href: "/siteadmin/big-projects/circumvention",
        icon: <SideMenuViewJobRatingsIcon />,
        isValidatePrivilege: false,
    },
]

// COMPLIANCE (CCPA/CPRA): consumer Data Rights (DSAR) admin queue. Rendered
// OUTSIDE the Large Projects group and NOT gated by `largeProjectsEnabled` —
// any user can file a DSAR at /data-rights, so admins always need this screen.
const privacyComplianceSideMenu = [
    {
        label: "dataRightsDsarMenu",
        activePaths: ["/siteadmin/big-projects/dsar"],
        href: "/siteadmin/big-projects/dsar",
        icon: <SideMenuManageUsersIcon />,
        isValidatePrivilege: false,
    },
]

const contentSideMenu = [

    {
        label: "contentpageManagement",
        activePaths: ["/siteadmin/contentpage"],
        href: "/siteadmin/contentpage/manage",
        icon: <SideMenuContentManageMentIcon />,
        isValidatePrivilege: true,
        privilegeId: 17,
    },

    {
        label: "staticpageManagement",
        activePaths: ["/siteadmin/staticpage"],
        href: "/siteadmin/staticpage/manage",
        icon: <SideMenuStaticContentManageMentIcon />,
        isValidatePrivilege: true,
        privilegeId: 16,
    },

    {
        label: "seoPagesManagement",
        activePaths: ["/siteadmin/seo"],
        href: "/siteadmin/seo",
        icon: <SideMenuContentManageMentIcon />,
        isValidatePrivilege: false,
    },

    {
        label: "reviewModeration",
        activePaths: ["/siteadmin/review-moderation"],
        href: "/siteadmin/review-moderation",
        icon: <SideMenuContentManageMentIcon />,
        isValidatePrivilege: false,
    },
]



export {
    getDashboardSideMenu,
    getConfigurationSideMenu,
    getAdminUserSideMenu,
    getUserSideMenu,
    getOpConfiguration,
    getJobsSideMenu,
    payoutSideMenu,
    monitorSideMenu,
    announcementSideMenu,
    bigProjectsSideMenu,
    privacyComplianceSideMenu,
    contentSideMenu
}

